module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "warp"
  }, [_c('el-col', {
    staticClass: "warp-breadcrum",
    attrs: {
      "span": 24
    }
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('b', [_vm._v("首页")])]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("题库管理")])], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "warp-main",
    attrs: {
      "span": 24,
      "element-loading-text": "拼命加载中"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.searchForm
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "请选择题目类型"
    },
    model: {
      value: (_vm.searchForm.type),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "type", $$v)
      },
      expression: "searchForm.type"
    }
  }, _vm._l((_vm.typeSelect), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "创建开始日期",
      "end-placeholder": "创建结束日期",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.searchForm.date),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "date", $$v)
      },
      expression: "searchForm.date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddDialog()
      }
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.questionbanks,
      "highlight-current-row": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "60",
      "fixed": "left",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "题目类型",
      "width": "120",
      "align": "center",
      "formatter": _vm.formatType
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "correct",
      "label": "正确选项",
      "width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "标题",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "创建时间",
      "width": "180",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updateDate",
      "label": "更新时间",
      "width": "180",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.showDetailDialog(scope.$index, scope.row)
            }
          }
        }, [_vm._v("详情")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.showEditDialog(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.delQuestion(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "page-sizes": [10, 20, 50, 100],
      "page-size": 10,
      "background": "",
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "标题"
    },
    model: {
      value: (_vm.addForm.data.title),
      callback: function($$v) {
        _vm.$set(_vm.addForm.data, "title", $$v)
      },
      expression: "addForm.data.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "题目类型"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addForm.data.type),
      callback: function($$v) {
        _vm.$set(_vm.addForm.data, "type", $$v)
      },
      expression: "addForm.data.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1",
      "border": ""
    }
  }, [_vm._v("单选题")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2",
      "border": ""
    }
  }, [_vm._v("判断题")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3",
      "border": ""
    }
  }, [_vm._v("多选题")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "正确选项"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "正确选项"
    },
    model: {
      value: (_vm.addForm.data.correct),
      callback: function($$v) {
        _vm.$set(_vm.addForm.data, "correct", $$v)
      },
      expression: "addForm.data.correct"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "答题选项"
    }
  }, [_c('el-row', [_c('el-button', {
    attrs: {
      "type": "success",
      "icon": "el-icon-plus",
      "size": "mini",
      "circle": ""
    },
    on: {
      "click": _vm.addForm.add
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.addForm.data.answers
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "optionCode",
      "label": "编码",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "optionContent",
      "label": "内容"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.addForm.edit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.addForm.delete(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "答题选项",
      "visible": _vm.answerFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.answerFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "answerForm",
    attrs: {
      "model": _vm.answerForm,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "选项编码"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "选项编码"
    },
    model: {
      value: (_vm.answerForm.optionCode),
      callback: function($$v) {
        _vm.$set(_vm.answerForm, "optionCode", $$v)
      },
      expression: "answerForm.optionCode"
    }
  }, _vm._l((_vm.answerCode), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选项内容"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "选项内容"
    },
    model: {
      value: (_vm.answerForm.optionContent),
      callback: function($$v) {
        _vm.$set(_vm.answerForm, "optionContent", $$v)
      },
      expression: "answerForm.optionContent"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.answerFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.answerForm.submit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.detailEditDialogTitle,
      "visible": _vm.detailEditDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.detailEditDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "标题"
    },
    model: {
      value: (_vm.addForm.data.title),
      callback: function($$v) {
        _vm.$set(_vm.addForm.data, "title", $$v)
      },
      expression: "addForm.data.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "题目类型"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addForm.data.type),
      callback: function($$v) {
        _vm.$set(_vm.addForm.data, "type", $$v)
      },
      expression: "addForm.data.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1,
      "border": ""
    }
  }, [_vm._v("单选题")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2,
      "border": ""
    }
  }, [_vm._v("判断题")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3,
      "border": ""
    }
  }, [_vm._v("多选题")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "正确选项"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "正确选项"
    },
    model: {
      value: (_vm.addForm.data.correct),
      callback: function($$v) {
        _vm.$set(_vm.addForm.data, "correct", $$v)
      },
      expression: "addForm.data.correct"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "答题选项"
    }
  }, [_c('el-row', [_c('el-button', {
    style: (_vm.detialEditDialogButton),
    attrs: {
      "type": "success",
      "icon": "el-icon-plus",
      "size": "mini",
      "circle": ""
    },
    on: {
      "click": _vm.addForm.add
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.addForm.data.answers
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "optionCode",
      "label": "编码",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "optionContent",
      "label": "内容",
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          style: (_vm.detialEditDialogButton),
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.addForm.edit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          style: (_vm.detialEditDialogButton),
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.addForm.delete(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    style: (_vm.detialEditDialogButton),
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailEditDialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a3cc446"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/exam/questionbank.vue
// module id = 1189
// module chunks = 2